import { tipoVistoriaConfig } from "@/mocks/vistorias";

interface InspectionTypeBadgeProps {
  type: string;
}

export default function InspectionTypeBadge({ type }: InspectionTypeBadgeProps) {
  const config = tipoVistoriaConfig[type] || { badge: "bg-background-100 text-foreground-500", icon: "ri-file-line" };
  return (
    <span className={`badge ${config.badge}`}>
      <i className={`${config.icon} mr-1 text-xs`}></i>
      {type}
    </span>
  );
}